module.exports = __webpack_public_path__ + "static/media/dg_full_resolution.3d841350.png";